<template>
    <div>
      <Head title="Signup for BacktoWorkConnect.ie" />
    <v-container style="background-color:primary">
        <LoginRegister @toggleDialog="toggleDialog()" :state="state" :baseurl="baseurl" :state="state" :redirectHome="true"></LoginRegister>
    </v-container>
    </div>
  </template>
  
  <script>
  import { Head } from '@inertiajs/inertia-vue'
  import Layout from '@/Shared/VuetifyLayout'
import { Link } from '@inertiajs/inertia-vue'
import LoginRegister from '@/Shared/LoginRegister'
import FlashMessages from '@/Shared/FlashMessages'

  export default {
    props: {
      locations: Array,
      baseurl: String,
      state: String,
      auth: Object,
    },
    components: {
      Head,
        FlashMessages,
        Link,
        LoginRegister,
  
    },
    layout: Layout,
    data() {
        return {
            keyword: "",
            location: "",
            category: "",
        }
    },
    methods: {
      toggleDialog() {
          console.log('toggledialog')
          window.open(this.baseurl)
      },
    }
  }
  </script>
  